export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: 'eeef389', dateTime: 1771004972629 };